const getPercentFromTime = (time, duration) => {
  return (time / duration) * 100
}
export default getPercentFromTime
